export type BreakpointKey = "sm" | "md" | "lg" | "xl" | "xxl" | "xxxl";

type BreakpointsConfig = Record<BreakpointKey, string>;
type ColumnsConfig = Record<BreakpointKey, number>;
type GuttersConfig = Record<BreakpointKey, string>;

export const breakpoints: BreakpointsConfig = {
  sm: "0rem",
  md: "37.5rem",
  lg: "62.5rem",
  xl: "80rem",
  xxl: "90rem",
  xxxl: "120rem",
};

export const columns: ColumnsConfig = {
  sm: 12,
  md: 12,
  lg: 12,
  xl: 12,
  xxl: 12,
  xxxl: 12,
};

export const gutters: GuttersConfig = {
  sm: "8px",
  md: "16px",
  lg: "16px",
  xl: "20px",
  xxl: "20px",
  xxxl: "20px",
};

export const outerGutters: GuttersConfig = {
  sm: "20px",
  md: "40px",
  lg: "40px",
  xl: "64px",
  xxl: "64px",
  xxxl: "64px",
};
